import { render, staticRenderFns } from "./FormMancataDichiarazione.vue?vue&type=template&id=4f28450a&scoped=true&"
import script from "./FormMancataDichiarazione.vue?vue&type=script&lang=js&"
export * from "./FormMancataDichiarazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f28450a",
  null
  
)

export default component.exports